module.exports = "  <div id=\"flash-message-container\" *ngFor=\"let message of messages\">\n    <div class=\"alert {{alertCategoryCssClass(message)}}\">\n      <a *ngIf=\"dismissable\" href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\" (click)=\"onMessageDismissed(message)\">&times;</a>\n      <strong>{{message.message}}</strong>\n    </div>\n  </div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/flash-message/flash-message.html
// module id = viac
// module chunks = 3